import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import logo3 from '../assets/images/logo3.png'; // Adjust the path to your logo

const OrderSuccess = () => {
  return (
    <div className="min-h-screen bg-[#f5f9ff] flex items-center justify-center p-4">
      <div className="bg-white p-8 md:p-10 rounded-xl shadow-lg max-w-md w-full text-center">
        {/* Logo Row */}
        <div className="flex items-center justify-center gap-3 mb-3">
          <img 
            src={logo3} 
            alt="SwachhAJV Logo" 
            className="h-10" 
          />
          <h5 className="text-[#00CD70] font-black text-3xl">SwachhAJV</h5>
        </div>

        {/* Success Icon */}
        <div className="text-green-500 text-5xl flex justify-center mb-4">
          <FaCheckCircle />
        </div>

        {/* Success Title */}
        <h2 className="text-2xl font-semibold text-gray-800 mb-3">
          Order Placed Successfully!
        </h2>

        {/* Success Message */}
        <p className="text-black text-lg mb-6">
          Thank you for your purchase. A confirmation email has been sent to you.
        </p>

        {/* Home Button */}
        <Link 
          to="/" 
          className="inline-block bg-[#00D084] hover:bg-[#3aca46] text-white font-medium py-2 px-5 rounded-md transition-colors"
        >
          Go to Home
        </Link>
      </div>
    </div>
  );
};

export default OrderSuccess;